"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('utils', [
        function () {
            return {
                getProps: function (obj, propString, optionalDefaultVal) {
                    var props = propString.split('.');
                    var value = lodash_1.default.chain(props)
                        .compact()
                        .reduce(function (theObj, prop) {
                        return theObj && theObj[prop];
                    }, obj)
                        .value();
                    return ((optionalDefaultVal != null) && (value == null)) ? optionalDefaultVal : value;
                },
                setExistingProps: function (obj, propString, val) {
                    if (lodash_1.default.has(obj, propString)) {
                        lodash_1.default.set(obj, propString, val);
                    }
                },
                makeWidgetKey: function (ids) {
                    return [ids.containerId, ids.pageId, ids.widgetId].join('.');
                }
            };
        }
    ]);
})((0, angular_1.module)('reporting.dashboards.services'));
